import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeftCaret = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 12,
	viewBox: "0 0 8 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.15493e-08 6L7.5 0.803846L7.5 11.1962L7.15493e-08 6Z",
		fill: "#282828"
	})
});
export default SvgLeftCaret;
